import Input from '../Input/InputWrapper';
import Select from '../Select/SelectWrapper';
import get from 'lodash/get';
import React from 'react';
import * as addressConsts from './addressConsts';
import classes from './AddressSearch.module.scss';
import AsyncSelect from 'react-select/async';
import styles from './AddressManual.module.scss';

const AddressManual = ({ values, name, onCountryChange, international, countries, ...props }) => {
  const intl = international ? classes.intl : '';
  const parts = [
    <div className={`${classes.colAddress} ${intl}`}>
      <Input
        style={{ error: classes.error }}
        value={get(values, `${name}.addressLine`, '')}
        name={`${name}.addressLine`}
        type="text"
        placeholder={'Address*'}
        innerClassName={`${classes.manualAddressField} ${props.classNames?.manualAddress ?? ''} ${
          props.showErrorsClass
        }`}
        aria-label="Address"
      />
    </div>,
    <div className={`${classes.colSuburb} ${intl}`}>
      <Input
        style={{ error: classes.error }}
        value={get(values, `${name}.suburb`, '')}
        name={`${name}.suburb`}
        type="text"
        placeholder={'Suburb*'}
        innerClassName={`${classes.manualAddressField} ${props.classNames?.manualSuburb ?? ''} ${
          props.showErrorsClass
        }`}
        aria-label="Suburb"
      />
    </div>,
  ];
  const addState = parts => {
    const currentState = get(values, `${name}.state`, '');
    parts.push(
      international ? (
        <div className={`${classes.colState} ${intl}`} translate="no">
          <Input
            style={{ error: classes.error }}
            value={currentState && currentState.label ? currentState.label : currentState}
            name={`${name}.state`}
            type="text"
            placeholder={'State*'}
            innerClassName={`${classes.manualAddressField} ${props.classNames?.manualState ?? ''} ${
              props.showErrorsClass
            }`}
            aria-label="State"
          />
        </div>
      ) : (
        <div className={`${classes.colState} ${intl}`} translate="no">
          <Select
            style={{ error: classes.error }}
            name={`${name}.state`}
            value={get(values, `${name}.state`, '')}
            placeholder={'State*'}
            innerClassName={`${classes.manualAddressField} ${props.classNames?.manualState ?? ''} ${
              props.showErrorsClass
            }`}
            options={addressConsts.stateList}
            aria-label="State"
          />
        </div>
      )
    );
  };

  const ctrs = countries ?? addressConsts.countryList;
  const countryOptions = inputValue =>
    new Promise(resolve => {
      resolve(ctrs.filter(d => d.label.toLowerCase().includes(inputValue.toLowerCase())));
    });

  const addCountry = parts =>
    parts.push(
      <div className={`${classes.colCountry} ${intl}`}>
        <AsyncSelect
          id={`${name}.country`}
          name={`${name}.country`}
          aria-label="Country"
          classNamePrefix="country-select"
          className={`${classes.manualAddressField} ${props.classNames?.manualState ?? ''} ${
            styles.select
          } ${props.showErrorsClass}`}
          cacheOptions
          defaultOptions={ctrs}
          value={ctrs.find(c => c.value === get(values, `${name}.country`, ''))}
          loadOptions={countryOptions}
          onChange={v => {
            if (onCountryChange) {
              onCountryChange(v.value);
            }
          }}
        />
      </div>
    );
  const addPostcode = parts =>
    parts.push(
      <div className={`${classes.colPostcode} ${intl}`}>
        <Input
          style={{ error: classes.error }}
          value={get(values, `${name}.postcode`, '')}
          name={`${name}.postcode`}
          type="text"
          placeholder={'Postcode*'}
          innerClassName={`${classes.manualAddressField} ${props.classNames?.manualPostcode ??
            ''} ${props.showErrorsClass}`}
          aria-label="Postcode"
        />
      </div>
    );

  if (international) {
    addState(parts);
    addCountry(parts);
    addPostcode(parts);
  } else {
    addState(parts);
    addPostcode(parts);
  }
  parts.push();
  return <div className={classes.addressManually}>{parts}</div>;
};

export default AddressManual;
